import './TextAnimation.scss';
document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".lpcb-block-text-animate-on-scroll");

    if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const target = entry.target;
                        const animationType = target.getAttribute("text-animation");

                        if (animationType && animationType !== "none") {
                            target.classList.add("has-text-animation");

                            target.classList.remove("lpcb-block-text-animate-on-scroll");
                            target.removeAttribute("text-animation");
                        }
                        observer.unobserve(target);
                    }
                });
            },
            {
                threshold: 0.7, // 指定数以上見えたら発火
            }
        );

        elements.forEach((el) => observer.observe(el));
    } else {
        // IntersectionObserver 未対応: 非表示事故を避けるため通常表示に戻す
        elements.forEach((target) => {
            target.classList.remove("lpcb-block-text-animate-on-scroll"); 
            target.removeAttribute("text-animation");
        });
    }
});